import { render, staticRenderFns } from "./SeleccionarRegionConSecciones.vue?vue&type=template&id=da462662"
import script from "./SeleccionarRegionConSecciones.vue?vue&type=script&lang=js"
export * from "./SeleccionarRegionConSecciones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports